import { render, staticRenderFns } from "./ItemsQuotationForm.vue?vue&type=template&id=313f52c7&scoped=true"
import script from "./ItemsQuotationForm.vue?vue&type=script&lang=js"
export * from "./ItemsQuotationForm.vue?vue&type=script&lang=js"
import style0 from "./ItemsQuotationForm.vue?vue&type=style&index=0&id=313f52c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f52c7",
  null
  
)

export default component.exports